"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
const user_settings_context_1 = require("../../settings/user/user-settings-context");
const react_1 = __importStar(require("react"));
const reporting_context_1 = require("../reporting/reporting-context");
const dnd_grid_1 = require("../../components/dnd-grid/dnd-grid");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const card_universal_1 = require("./cards/universal/card-universal");
const dashboard_add_dialog_1 = require("./dashboard-add-dialog");
const dashboard_card_1 = require("./dashboard-card");
const dashboard_context_1 = require("./dashboard-context");
function defaultCardFactory() {
    return card_universal_1.CardUniversal;
}
const emptyArray = [];
function Dashboard({ cardFactory = defaultCardFactory, fixedDefinitions = emptyArray, classes, }) {
    const { loadDefinitions } = (0, react_1.useContext)(reporting_context_1.ReportingContext);
    const [definitions, setDefinitions] = (0, react_1.useState)();
    const addDialogRef = (0, react_1.useRef)(null);
    const { getCustomSettings, setCustomSettings } = (0, react_1.useContext)(user_settings_context_1.UserSettingsContext);
    const saveDashboard = (0, event_callback_hook_1.useEventCallback)((items) => {
        items = items.filter((item) => item !== 'ADD');
        const settings = {
            items,
            version: 1,
        };
        setCustomSettings('dashboard', settings);
    });
    const loadDashboard = (0, react_1.useCallback)(() => {
        var _a;
        const settings = getCustomSettings('dashboard', 1);
        const items = (_a = settings === null || settings === void 0 ? void 0 : settings.items) !== null && _a !== void 0 ? _a : [];
        const supportedDefinitions = definitions.filter((definition) => definition.dashboardSupport);
        const allowedItems = items.filter((item) => {
            return supportedDefinitions.find((d) => d.id === item) !== undefined;
        });
        if (allowedItems.length !== items.length) {
            saveDashboard(allowedItems);
        }
        if (allowedItems.length !== supportedDefinitions.length) {
            return [...allowedItems, 'ADD'];
        }
        return [...allowedItems];
    }, [getCustomSettings, definitions, saveDashboard]);
    const openAddDialog = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        (_a = addDialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const remove = (0, event_callback_hook_1.useEventCallback)((id) => {
        saveDashboard(loadDashboard().filter((value) => value !== id));
    });
    (0, react_1.useEffect)(() => {
        loadDefinitions().then((definitions) => {
            const filteredFixedDefinitions = fixedDefinitions.filter((fixedDefinition) => !definitions.some((definition) => definition.id === fixedDefinition.id));
            setDefinitions([...definitions, ...filteredFixedDefinitions]);
        });
    }, [fixedDefinitions, loadDefinitions]);
    return (react_1.default.createElement(react_1.default.Fragment, null, definitions !== undefined && (react_1.default.createElement(dashboard_context_1.DashboardContext.Provider, { value: {
            definitions: definitions,
            classes,
            cardFactory,
            loadDashboard,
            saveDashboard,
            openAddDialog,
            remove,
        } },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(dnd_grid_1.DndGrid, { columns: 4, value: [...loadDashboard()], onChange: saveDashboard, ItemComponent: dashboard_card_1.DashboardCard }),
            react_1.default.createElement(dashboard_add_dialog_1.DashboardAddDialog, { ref: addDialogRef }))))));
}
exports.Dashboard = Dashboard;
//# sourceMappingURL=dashboard.js.map